import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ELIGIBLE_LIMIT, getApplicationId, getContactUsDetails, showSupportNumberForAllCustomer, showSupportNUmberForPartner } from "../../../../configs/utils";
import { api } from "../../../../configs/api";
import { getAppHeader } from "../../../../configs/config";
import { ACTION } from "./utils";
import { goBackAction, refreshPortfolioAction, setCreditLimitAction, viewYourMutualFundsAction } from "./actions";
import SharedPropsService from "../../../../SharedPropsService";
import { getTotalLimit } from "../../../mfPledge/portfolio/actions";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
export const template = async (height, contactUsDetails, pledgeLimitResponse, isFromEnhanceLimit, pledgeDetails) => {
    return {
        layout: {
            id: ROUTE.MFC_FETCH_ANCHOR,
            type: LAYOUTS.LIST,
            style: {
                isFromPartnerPlatform: true
            },
            widgets: [
                { id: "mfcFetchAnchorScreen", type: WIDGET.MFC_FETCH_ANCHOR }
            ],
        },
        datastore: {
            mfcFetchAnchorScreen: {
                height: height,
                contactUsDetails: contactUsDetails,
                refreshPortfolioAction: {
                    type: ACTION.REFRESH_PORTFOLIO,
                    routeId: ROUTE.MFC_FETCH_ANCHOR,
                    payload: {}
                },
                setCreditLimitAction: {
                    type: ACTION.SET_CREDIT_LIMIT,
                    routeId: ROUTE.MFC_FETCH_ANCHOR,
                    payload: {}
                },
                viewYourMutualFundsAction: {
                    type: ACTION.VIEW_YOUR_MUTUAL_FUNDS,
                    routeId: ROUTE.MFC_FETCH_ANCHOR,
                    payload: {}
                },
                goBackAction: {
                    type: ACTION.GO_BACK_ACTION,
                    routeId: ROUTE.MFC_FETCH_ANCHOR,
                    payload: {}
                },
                pledgeLimitResponse: pledgeLimitResponse,
                isFromEnhanceLimit: isFromEnhanceLimit,
                pledgeDetails: pledgeDetails
            }
        },
    };
};
export const mfCentralFetchAnchorMf = {
    onLoad: async ({ getHeight, network, instrumentTrack }, { setShowSupportPhoneNumber }) => {
        await instrumentTrack("MFC_ELIGIBLE_LIMIT_SCREEN_VIEWED");
        const applicationId = await getApplicationId();
        const getPledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        const pledgeLimitResponse = await network
            .get(`${api.pledgeLimit}${applicationId}`, { headers: await getAppHeader() });
        await SharedPropsService.setAuthCASResponse(pledgeLimitResponse?.data);
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        const updateAvailableCASMap = {};
        stepResponseObject.availableCAS.map((item, index) => {
            const key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        await SharedPropsService.setCreditLimit(getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap));
        const isFromEnhanceLimit = await AsyncStorage.getItem("application_id") !== null;
        const showSupportNumber = await showSupportNumberForAllCustomer();
        const showSupportNUmberForPartnerCustomer = await showSupportNUmberForPartner();
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
            0;
        const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
            0;
        if (availableCreditAmount >= ELIGIBLE_LIMIT.MIN_LIMIT || totalPortfolioAmount >= ELIGIBLE_LIMIT.MAX_AMOUNT || showSupportNumber) {
            if (Platform.OS === 'web') {
                setShowSupportPhoneNumber(true);
            }
            await SharedPropsService.setSupportPhoneNumber(true);
        }
        else {
            if (Platform.OS === 'web') {
                setShowSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
            }
            await SharedPropsService.setSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
        }
        const contactUsDetails = await getContactUsDetails();
        return Promise.resolve(template(getHeight(), contactUsDetails, pledgeLimitResponse?.data, isFromEnhanceLimit, getPledgeDetails?.data));
    },
    actions: {
        [ACTION.REFRESH_PORTFOLIO]: refreshPortfolioAction,
        [ACTION.SET_CREDIT_LIMIT]: setCreditLimitAction,
        [ACTION.VIEW_YOUR_MUTUAL_FUNDS]: viewYourMutualFundsAction,
        [ACTION.GO_BACK_ACTION]: goBackAction,
    },
    clearPrevious: true,
};
